import RangePicker from '@home/components/RangePicker';
import { DBO_TM } from '@op/utils/format';
import moment, { Moment } from 'moment';
import React, { useMemo } from 'react';
import {
  moreKeyCommonMapStateToProps,
  moreKeyCommonMapDispatchToProps,
} from '../../connect/moreKeyCommon';
import { connect } from 'umi';
import {
  IDateCommonSelectType,
  IDateConfig,
  ISingleDateCommonType,
} from '../../types';
import useIntls from '@opm/hooks/useIntls';

function SingleDateSelect({
  filterValue,
  valueKeys,
  change,
  optionsMap = { '1day': { value: '1day', text: 'Day', text_cn: '天' } },
  defaultValue = { '1day': [DBO_TM.utc(), DBO_TM.utc()] },
  type = '1day',
  typeList = ['1day'],
  startOfTime = '2001-01-01',
  disabledDate
}: IDateCommonSelectType & ISingleDateCommonType & IDateConfig) {
  const { isEn } = useIntls();

  const rangePickerValue = useMemo(() => {
    const { start_time, end_time } = valueKeys;
    return [start_time, end_time].map((key) => moment(filterValue[key]));
  }, [filterValue]);

  // 获取时间的开始和结束时间 如果改变日期，这里value会返回[null, null]
  const onChangeRangePicker = (value: [Moment, Moment]) => {
    const [start_time, end_time] = value;
    const { startTime, endTime } = {
      startTime: start_time
        .startOf('day')
        .startOf('hour')
        ?.format('YYYY-MM-DD HH:mm:ss'),
      endTime: end_time
        .endOf('day')
        .endOf('hour')
        ?.format('YYYY-MM-DD HH:mm:ss'),
    };
    change({
      [valueKeys.start_time]: startTime,
      [valueKeys.end_time]: endTime,
      [valueKeys.date_type]: 'daily',
    });
  };

  return (
    <div className="date-select-wrapper search-item search-item-date date-select-wrapper-hour">
      <RangePicker
        autoStartDay={false}
        onChange={onChangeRangePicker}
        typeList={[typeList]}
        type={type}
        defaultValue={defaultValue}
        startOfTime={startOfTime}
        optionsMap={optionsMap}
        showSelectType={false}
        value={rangePickerValue}
        disables={false} 
        language={isEn ? 'en' : 'cn'}
        hourLeftSide={false}
        disabledDate={disabledDate}
      />
    </div>
  );
}

export default connect(
  moreKeyCommonMapStateToProps,
  moreKeyCommonMapDispatchToProps,
)(SingleDateSelect);
